import Raven from 'raven-js';
import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
export const fetchLimitUsage = () => {
  return http.get(`${getFullUrl('app-api')}/feature/store/v1/usage`).catch(error => {
    Raven.captureException(new Error('Failed to fetch limit usage'), {
      extra: {
        error
      }
    });
    throw error;
  });
};